




















import {Component, Prop, Vue} from 'vue-property-decorator'

@Component
export default class Status extends Vue {
    @Prop({
        required: true,
        type: String
    })
    private itemHeader?: string

    @Prop({
        required: true,
        type: String
    })
    private summary?: string

    get header() {
        return this.itemHeader
    }

    get health() {
        return this.summary == "OK"
    }

}
